import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getMethod } from "../../utils/apiServices";

export const getLandTitle = createAsyncThunk(
  "landTitle/fetchLandTitle",
  async () => {
    // setAuthorizationToken(true);
    const response = await getMethod(`/api/land-title`);
    return response;
  }
);

const initialState = {
  loading: false,
  success: false,
  error: false,
  landTitle: null,
};

const landTitleSlice = createSlice({
  name: "landTitle",
  initialState,
  // reducers: {
  //   isLoading: (state) => {
  //     state.loading = true;
  //     state.success = false;
  //     state.error = false;
  //   },
  //   isSuccess: (state, action) => {
  //     state.loading = false;
  //     state.success = true;
  //     state.error = false;
  //     state.landTitle = action.payload;
  //   },
  //   isError: (state) => {
  //     state.loading = false;
  //     state.success = false;
  //     state.error = true;
  //   },
  // },

  extraReducers: (builder) => {
    builder.addCase(getLandTitle.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getLandTitle.fulfilled, (state, action) => {
      state.loading = false;
      state.landTitle = action.payload.data;
    });
    builder.addCase(getLandTitle.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });
  },
});

// export const { isLoading, isSuccess, isError } = landTitleSlice.actions;

export default landTitleSlice.reducer;

// export const getLandTitle = () => async (dispatch) => {
//   try {
//     dispatch(isLoading);
//     const response = await getMethod(`/api/land-title`);
//     dispatch(isSuccess(response?.data));
//   } catch (error) {
//     dispatch(isError);
//   }
// };
